import {Component} from '@angular/core';
import {Router, ActivatedRoute} from '@angular/router';
import {DataTable} from "../../services/DataTable";
import {ClientsService} from "../../models/clients/clients.service";
import {ClientStatusType} from "../../models/clients/clients.type";
import {phoneFormatter} from "../../helpers/phone-format";


@Component({
    selector: 'incomplete',
    templateUrl: 'incomplete.template.html'
})
export class IncompleteComponent{
    phoneFormatter = phoneFormatter;

    public dataTable: DataTable;
    public statuses: Array<any>;

    // ===========================================================
    // Init
    // ===========================================================

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        public clientsService: ClientsService
    ) {
        this.dataTable = new DataTable(this.clientsService, this.getFields());
        this.dataTable.fetch();
    }

    ngOnInit() {
        this.statuses =  this.clientsService.getStatusIncomplete();
    }

    // ===========================================================
    // Actions
    // ===========================================================

    public openOne(model) {
        this.router.navigate(['../clients/' + model.id], {relativeTo: this.route})
    }

    // ===========================================================
    // Functions
    // ===========================================================

    public refreshTable() {
        this.dataTable.refresh();
    }

    private getFields(){
        return [{'visible':  ClientsService.CLIENT_VISIBLE_TRUE}, {'status': ClientStatusType.INCOMPLETE}];
    }

}


// WEBPACK FOOTER //
// ./src/app/modules/incomplete/incomplete.component.ts